import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = {
  class: "hdr-outer",
  id: "headerScroll"
}
const _hoisted_2 = {
  class: "lmd-menu",
  id: "menuOpen"
}
const _hoisted_3 = { class: "lmd-header" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "custom-row" }
const _hoisted_6 = { class: "site-logo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", null, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/' }),
              to: "/",
              id: "homeMenuLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { title: "Home" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Home", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/our-services' }),
              to: "/our-services",
              id: "ourServicesLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { title: "Services" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Services", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/Industries' }),
              to: "/Industries",
              id: "ourIndustriesLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { title: "Industries" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Industries", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/client' }),
              to: "/client",
              id: "ourClientsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", { title: "Clients" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Clients", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/career' }),
              to: "/career",
              id: "ourCareersLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { title: "Career" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Careers", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/our-team' }),
              to: "/our-team",
              id: "ourTeamLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("i", { title: "Teams" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Our Team", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/about-us' }),
              to: "/about-us",
              id: "AboutUsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("i", { title: "About-us" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "About Us", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/blogs' }),
              to: "/blogs",
              id: "BlogsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { title: "Blogs" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Blogs", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/employee/login' }),
              to: "/employee/login",
              id: "BlogsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { title: "Blogs" }, null, -1),
                _createTextVNode(),
                _createElementVNode("span", null, "Employee Login", -1)
              ]))]),
              _: 1
            }, 8, ["class", "onClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
                  alt: "Logo"
                })
              ]),
              _: 1
            })
          ]),
          _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"lmd-hdr-right\"><div class=\"menu-icon\"><button id=\"menuclick\"><span class=\"hamb-top\"></span><span class=\"hamb-mid\"></span><span class=\"hamb-btm\"></span></button></div></div>", 1))
        ])
      ])
    ])
  ]))
}